<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>云算力购买记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker
          v-model="times"
          type="daterange"
          range-separator="至"
          start-placeholder="开售时间"
          end-placeholder="停售时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-input placeholder="请输入用户ID" v-model="form.userId"></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import List from "./components/list";
import moment from "moment";

export default {
  name: "mortgagerecord",
  data() {
    return {
      form: {},
      times: []
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState("miningRecord", ["pagination", "coinTypeList"]),
    startTime() {
      return this.times ? this.times[0] : "";
    },
    endTime() {
      return this.times ? this.times[1] : "";
    }
  },
  methods: {
    ...mapActions("miningRecord", ["getRecords"]),
    handleSearch() {
      this.getList({
        page: 1,
        startTime: this.startTime,
        endTime: this.endTime
      });
    },
    getList(data = {}) {
      this.getRecords({
        ...this.form,
        ...this.pagination,
        ...data
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
